import { atom } from 'recoil';
import { IComponent } from '../../../types';

export const myComponentListState = atom<IComponent[]>({
  key: 'myComponentListState',
  default: []
});
